export default __webpack_public_path__ + "static/media/facebook.2fa20280.svg";